import { render, staticRenderFns } from "./product-item-price-group.vue?vue&type=template&id=50708df8&"
import script from "./product-item-price-group.vue?vue&type=script&setup=true&lang=ts&"
export * from "./product-item-price-group.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports